import { compose, lifecycle, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import Services from '../services';
import {
  activeShop,
  getActiveBrandId,
  getActiveBrandName,
  getBarberUser,
  getIsRentalBarber,
  getRoleIdType,
} from '../../../auth/selectors';
import { bindActionsForRoles, withActionByRole } from '../../../common/helpers/actions';
import * as actions from '../actions';
import { getAll } from '../selector';
import withPermissions from '../../../auth/utils/withPermissions';
import { canUserAddServices, canUserModifyServices, canUserViewServices } from '../../../common/helpers/users';
import { getBarbers } from '../../barbers/actions';
import { getAll as getAllBarbers } from '../../barbers/selector';
import { ChurnZeroService, DOWNLOAD_SERVICES_LIST } from '../../../../modules/infra/observability/churnzero';
import { getUpdatedOrder } from '../utils/updateServiceOrder';

const mapStateToProps = state => ({
  roleIdType: getRoleIdType(state),
  brandId: getActiveBrandId(state),
  brandName: getActiveBrandName(state),
  barberUser: getBarberUser(state),
  shop: activeShop(state),
  barbers: getAllBarbers(state),
  services: getAll(state),
  isRentalBarber: getIsRentalBarber(state),
});

export default compose(
  connect(mapStateToProps),
  connect(null, (dispatch, props) => {
    const actionsForRoles = bindActionsForRoles(
      dispatch,
      actions.exportShopServicesCsv,
      actions.exportBarberServicesCsv,
      actions.exportBrandServicesCsv
    );

    const actionArgumentsByRole = {
      shop: [props.shop],
      barber: [props.barberUser],
      brand: [{ id: props.brandId, name: props.brandName }],
    };
    const args = actionArgumentsByRole[props.roleIdType.type];

    return {
      exportCsv: () => {
        ChurnZeroService.track(DOWNLOAD_SERVICES_LIST);
        return actionsForRoles[props.roleIdType.type](...args);
      },
      getShopBarbers: () => dispatch(getBarbers(props.shop.id)),
    };
  }),
  withActionByRole(
    'getServices', actions.getShopUserServicesV2, actions.getBarberUserServicesV2, actions.getBrandUserServices,
  ),
  withActionByRole(
    'updateServiceOrder',
    actions.updateShopUserServiceOrder,
    actions.updateBarberUserServiceOrder,
    actions.updateBrandUserServiceOrder,
  ),
  withProps((ownProps) => {
    if (ownProps.roleIdType.type === 'brand') {
      return { link: '/brand/services/add' };
    }

    return { link: ownProps.roleIdType.type === 'shop' ? '/services/add' : '/barber/services/add' };
  }),
  withHandlers({
    updateServiceList: props => (currentOrder, moveFromIndex, moveToIndex) => {
      props.updateServiceOrder(getUpdatedOrder(currentOrder, moveFromIndex, moveToIndex));
    },
  }),
  withPermissions,
  withProps((props) => {
    const { permissions, isRentalBarber, barbers, shop } = props;
    const canModifyOrAddServices = canUserModifyServices(permissions) || canUserAddServices(permissions);
    const hasEnoughPermissions = canUserViewServices(permissions) && canModifyOrAddServices;

    // artificially hide categories from barbers on client
    // API access is not restricted
    const isIndyBarber = isRentalBarber && shop.brand.shopCount === 1 && barbers.length === 1;
    const isNotBarberOrIndyBarber = props.roleIdType.type !== 'barber' || isIndyBarber;

    return {
      shouldShowCategoriesLink: isNotBarberOrIndyBarber && hasEnoughPermissions,
      shouldShowAddServiceButton: canUserAddServices(permissions),
    };
  }),
  lifecycle({
    componentDidMount() {
      this.props.getServices();

      if (this.props.isRentalBarber) {
        this.props.getShopBarbers();
      }
    },

    componentWillReceiveProps(nextProps) {
      // Update list if shop is changed from the navigation
      if (this.props.shop !== nextProps.shop) {
        this.props.getServices();
      }
    },
  })
)(Services);
